import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faHouse } from '@fortawesome/free-solid-svg-icons';
import { Avatar } from '../../components';
import { P, pillSt } from '../../theme/tokens';

const Main = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => p.$gap || 4}px;
  min-width: 0;
  font-size: 12px;
  color: ${P.muted};
`;

const Name = styled.b`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${P.ink};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Time = styled.span`
  font-size: 11.5px;
  white-space: nowrap;
`;

const Ell = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Dir = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 600;
  white-space: nowrap;
  color: ${(p) => (p.$out ? '#434343' : '#1D4F86')};
`;

const chip = (c) => pillSt(c, { padding: '2px 9px', lineHeight: '18px', border: 'none' });

export default function CallCard({ call, assistantName }) {
  const out = call.direction === 'outbound';
  const topic = call.summary || call.action;
  return (
    <>
      <Avatar name={call.name} size={30} />
      <Main>
        <Line $gap={6}>
          <Name>{call.name}</Name>
          <Time>{call.date === 'Today' ? call.time : `${call.date}, ${call.time}`}</Time>
        </Line>
        {call.property && (
          <Line $gap={6} style={{ fontSize: 12.5 }}>
            <FontAwesomeIcon icon={faHouse} style={{ fontSize: 10 }} />
            <Ell>{call.property}</Ell>
          </Line>
        )}
        <Line>
          <Dir $out={out}>
            <FontAwesomeIcon icon={out ? faArrowUp : faArrowDown} />
            {out ? 'Outbound' : 'Inbound'}
          </Dir>
          <Ell>{`· ${call.duration} · ${call.handledBy === 'team' ? 'Team' : assistantName}`}</Ell>
        </Line>
        <Line $gap={6}>
          <span style={chip(call.type.color)}>{call.type.label}</span>
          {topic && <Ell>{topic}</Ell>}
        </Line>
      </Main>
    </>
  );
}
